import React from "react";

import { Button2 } from "@/ui2/atoms/Button";
import EditIcon from "@/assets/images/icons2/icon--edit.svg?component";

export function EmptyGoalsDisplay({ onAddGoalClick, shouldShowAddGoal }) {
  return (
    <div className="CarePlanScreenings--empty-container">
      <div className="CarePlanScreenings--empty">
        <div className="CarePlanScreenings--empty-text">
          {!shouldShowAddGoal && <p>No goals or objectives.</p>}

          {shouldShowAddGoal && (
            <div className="tw:flex tw:items-center tw:gap-ch">
              <Button2
                icon={<EditIcon />}
                onPress={() => onAddGoalClick()}
                size="xs"
                variant="link"
              >
                Add Goal
              </Button2>

              <small className="body-xs">(Max 3)</small>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
